import(/* webpackMode: "eager", webpackExports: ["NotFoundContent"] */ "/home/runner/work/apollo/apollo/packages/shells/shared/src/presentation/organisms/not-found-content/not-found-content.tsx");
